import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
export default function ConfirmPage() {
    const { pathname } = useLocation();
const canonicalUrl = `https://www.vhotelthegrandshoba.com${pathname}`;
  return (
    <>
      {/* SEO */}
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href={`https://www.vhotelthegrandshoba.com${pathname}`} />

      </Helmet>
      <div className="seventh-main">
        {/* <img src="/images/dine/dine-2/dine-2.jpg" alt="seventh sense images" /> */}
        <img src="/images/payment/CONFIRMED.png" loading="lazy" alt=" Confirm Online payment Image for V Hotel The Grand Shoba" />

      </div>

      <div classNameName="container-fluid banner" style={{ marginTop: 20 }}>
      </div>


      <div className="untree_co-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center pt-5">
       
              <h2 className="display-3 text-black">Thank you!</h2>
              <p className="lead mb-5">You Booking Has Been Successfully Complete.</p>
              <p><Link to="/" className="btn-primary">Back to Home</Link></p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}